import { CheckoutCompletedRenewalConfirmation } from '../../models/checkout-completed-item/checkout-completed-renewal-confirmation.interface';

export const mockCheckoutCompletedRenewalConfirmation: CheckoutCompletedRenewalConfirmation =
  {
    planNumber: 'planNumber',
    coverStartDate: '2022-03-05',
    digitalId: undefined,
  };
